<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :actions="actions"
      :title="title"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      :beforeSetupGrid="beforeSetupGrid"
      :selectionEnabled="true"
      ref="grid"
    ></dx-grid>

    <v-dialog persistent v-model="addNewDriverDialog" max-width="500">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0 pb-3">New Driver</v-card-title>
        <v-autocomplete
          class="mx-1 mb-0"
          label="Employee"
          placeholder="Start typing..."
          hide-no-data
          ref="selectedEmployee"
          v-model="selectedEmployee"
          :items="employees.map((b) => b.displayName)"
          :search-input.sync="loadEmployeeSearch"
          @change="onEmployeeSelected"
        ></v-autocomplete>
        <v-text-field
          class="mx-1 mb-2"
          v-model="newDriver.name"
          label="Name"
          ref="newName"
          :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
          class="mx-1 mb-2"
          v-model="newDriver.nameHeb"
          label="Hebrew Name"
          ref="newNameHeb"
          :rules="[rules.required]"
        ></v-text-field>

        <div v-for="(bus, index) in newDriver.buses">
          <v-layout row>
            <v-layout column>
              <v-layout row class="">
                <v-select
                  class="mx-1 mb-0"
                  label="Bus Number"
                  v-model="bus.busNumber"
                  :items="busList.map((b) => b.busNumber)"
                  ref="newBusNumber"
                  :rules="[(value) => rules.busNumberRequired(value, bus)]"
                ></v-select>
                <v-menu
                  v-model="bus.datePickerMenuFrom"
                  :close-on-content-click="true"
                  offset-y
                  full-width
                  prepend-icon="mdi-currency-usd"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="bus.dateFrom"
                      :value="formatedDate(bus.dateFrom)"
                      label="From Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="bus.dateFrom"></v-date-picker>
                </v-menu>
                <v-menu
                  v-model="bus.datePickerMenuTo"
                  :close-on-content-click="true"
                  offset-y
                  full-width
                  prepend-icon="mdi-currency-usd"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="bus.dateTo"
                      :value="formatedDate(bus.dateTo)"
                      label="To Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="bus.dateTo"></v-date-picker>
                </v-menu>
              </v-layout>
            </v-layout>
            <v-layout align-center class="mr-3">
              <v-btn @click.stop="addBus" flat icon color="success">
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
              <v-btn @click.stop="removeBus(index)" flat icon color="#f55a4e">
                <v-icon>mdi-minus-circle-outline</v-icon>
              </v-btn>
            </v-layout>
          </v-layout>
        </div>

        <v-card-actions class="mx-0 px-2 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="addNewDriverDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="saveNewDriver()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="updateDriverDialog" max-width="500">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0 pb-3"
          >Update Driver</v-card-title
        >

        <v-layout row v-if="rowClicked.name" class="mb-2">
          <div class="font-weight-medium mr-2">Name:</div>
          <div>{{ rowClicked.name }}</div>
        </v-layout>
        <v-layout row v-if="rowClicked.nameH" class="mb-3">
          <div class="font-weight-medium mr-2">Hebrew Name:</div>
          <div>{{ rowClicked.nameH }}</div>
        </v-layout>

        <!-- <v-autocomplete
                    class="mx-1 mb-0"
                    label="Employee"
                    placeholder="Start typing..."
                    hide-no-data
                    ref="clickedEmployee"
                    v-model="clickedEmployee"
                    :items="employees2.map((b) => b.displayName)"
                    :search-input.sync="loadClickedEmployeeSearch"
                    @change="onClickedEmployeeSelected"
                ></v-autocomplete>
                <v-text-field
                    class="mx-1 mb-2"
                    v-model="rowClicked.name"
                    label="Name"
                    ref="name"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                    class="mx-1 mb-2"
                    v-model="rowClicked.nameHeb"
                    label="Hebrew Name"
                    ref="nameHeb"
                    :rules="[rules.required]"
                ></v-text-field> -->

        <v-btn class="mt-0 pt-0" small color="success" @click="openUpdateBus"
          >Update Bus</v-btn
        >
        <v-btn
          class="ml-2 mt-0 pt-0"
          small
          dark
          color="default"
          v-if="getActiveBuses().length"
          @click="openDeactivateDriver"
          >Deactivate Bus</v-btn
        >
        <div style="overflow-y: auto; height: 300px">
          <div v-for="(bus, index) in rowClicked.buses">
            <div
              v-bind:class="{
                'active-bus': !bus.isArchived,
                'inactive-bus inactive-bus-text': bus.isArchived,
              }"
              class="pl-3 pr-1 mb-1"
            >
              <v-layout row class="mb-0">
                <div class="font-weight-medium mr-2 pt-2">
                  Bus Number:
                </div>
                <div class="pt-2">
                  {{ bus.busNumber }}
                </div>
                <v-spacer></v-spacer>
                <v-btn
                  class="pt-0 my-0"
                  flat
                  icon
                  color="success"
                  v-bind:class="{
                    'inactive-bus-text': bus.isArchived,
                  }"
                  :disabled="!!bus.isArchived"
                  @click.stop="openDeleteBus(bus)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-layout>
              <v-layout row class="mb-2">
                <div class="font-weight-medium mr-2">
                  Start Date:
                </div>
                <div>
                  {{ bus.dateFrom }}
                </div>
              </v-layout>
              <v-layout row class="mb-2">
                <div class="font-weight-medium mr-2">
                  End Date:
                </div>
                <div>
                  {{ bus.dateTo }}
                </div>
              </v-layout>
            </div>
          </div>
        </div>

        <v-card-actions class="mx-0 pl-2 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click.stop="updateDriverDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click.stop="saveDriver()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="deactivateBusDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Deactivate Bus</v-card-title>

        <div v-if="getExistingDataForBusMessage(true)">
          <div class="text-danger font-weight-medium">
            {{ getExistingDataForBusMessage(true) }}
          </div>

          <div
            class="font-weight-medium title mt-3"
            v-if="
              existingDataForBus.routeSchedules &&
                existingDataForBus.routeSchedules.length
            "
          >
            Route Schedules
          </div>

          <div
            style="overflow-y: auto; height: 150px; border: 1px solid #4caf50; padding: 8px;"
            v-if="
              existingDataForBus.routeSchedules &&
                existingDataForBus.routeSchedules.length
            "
          >
            <div
              v-for="(routeSchedule,
              index) in existingDataForBus.routeSchedules"
            >
              <div
                class="font-weight-regular"
                v-if="routeSchedule.route && routeSchedule.route.id"
              >
                {{ routeSchedule.route.routeIdentifier }}
              </div>
              <div
                class="caption"
                v-if="routeSchedule.route && routeSchedule.route.id"
              >
                {{
                  routeSchedule.route.timeStart +
                    " - " +
                    routeSchedule.route.buildings +
                    " - " +
                    (routeSchedule.route.grades
                      ? routeSchedule.route.grades
                      : "")
                }}
              </div>
              <v-divider
                class="my-2"
                v-if="index + 1 < existingDataForBus.routeSchedules.length"
              ></v-divider>
            </div>
          </div>
          <div
            class="font-weight-medium title mt-3"
            v-if="
              existingDataForBus.absents && existingDataForBus.absents.length
            "
          >
            Absents
          </div>
          <div
            style="overflow-y: auto; height: 150px; border: 1px solid #4caf50; padding: 8px;"
            v-if="
              existingDataForBus.absents && existingDataForBus.absents.length
            "
          >
            <div v-for="(absent, index) in existingDataForBus.absents">
              <div class="font-weight-regular" v-if="absent.id">
                {{ absent.date | date }}
              </div>
              <div class="caption" v-if="absent.id">
                {{
                  absent.timeStart +
                    " - " +
                    absent.buildings +
                    " - " +
                    (absent.grades ? absent.grades : "")
                }}
              </div>
              <v-divider
                class="my-2"
                v-if="index + 1 < existingDataForBus.absents.length"
              ></v-divider>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="font-weight-regular">
            This will deactivate the Bus
          </div>
        </div>
        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click.stop="deactivateBusDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :disabled="!!getExistingDataForBusMessage(true)"
            :loading="processing"
            color="success"
            @click.stop="deactivateDriver()"
          >
            Deactivate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="updateBusDialog" max-width="900">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Update Bus</v-card-title>
        <v-layout row>
          <v-layout column xs6 class="pr-2" style="min-width: 50%">
            <div>
              <v-layout row class="mb-2 mt-3">
                <div class="font-weight-medium mr-2">
                  Current Bus Number:
                </div>
                <div>
                  {{ rowClicked.busNumbers }}
                </div>
              </v-layout>
              <v-select
                class="mt-2 mx-0"
                outline
                label="Bus Number"
                v-model="rowClicked.newBusNumber"
                :items="busList.map((b) => b.busNumber)"
                ref="newBusNumber"
                :rules="[rules.required]"
              ></v-select>
            </div>
            <v-spacer></v-spacer>
          </v-layout>

          <v-layout column xs6 class="pl-2" style="min-width: 50%">
            <div v-if="getExistingDataForBusMessage()">
              <div class="text-danger font-weight-medium">
                {{ getExistingDataForBusMessage() }}
              </div>

              <div
                class="font-weight-medium title mt-3"
                v-if="
                  existingDataForBus.routeSchedules &&
                    existingDataForBus.routeSchedules.length
                "
              >
                Route Schedules
              </div>

              <div
                style="overflow-y: auto; height: 150px; border: 1px solid #4caf50; padding: 8px;"
                v-if="
                  existingDataForBus.routeSchedules &&
                    existingDataForBus.routeSchedules.length
                "
              >
                <div
                  v-for="(routeSchedule,
                  index) in existingDataForBus.routeSchedules"
                >
                  <div
                    class="font-weight-regular"
                    v-if="routeSchedule.route && routeSchedule.route.id"
                  >
                    {{ routeSchedule.route.routeIdentifier }}
                  </div>
                  <div
                    class="caption"
                    v-if="routeSchedule.route && routeSchedule.route.id"
                  >
                    {{
                      routeSchedule.route.timeStart +
                        " - " +
                        routeSchedule.route.buildings +
                        " - " +
                        (routeSchedule.route.grades
                          ? routeSchedule.route.grades
                          : "")
                    }}
                  </div>
                  <v-divider
                    class="my-2"
                    v-if="index + 1 < existingDataForBus.routeSchedules.length"
                  ></v-divider>
                </div>
              </div>
              <div
                class="font-weight-medium title mt-3"
                v-if="
                  existingDataForBus.absents &&
                    existingDataForBus.absents.length
                "
              >
                Absents
              </div>
              <div
                style="overflow-y: auto; height: 150px; border: 1px solid #4caf50; padding: 8px;"
                v-if="
                  existingDataForBus.absents &&
                    existingDataForBus.absents.length
                "
              >
                <div v-for="(absent, index) in existingDataForBus.absents">
                  <div class="font-weight-regular" v-if="absent.id">
                    {{ absent.date | date }}
                  </div>
                  <div class="caption" v-if="absent.id">
                    {{
                      absent.timeStart +
                        " - " +
                        absent.buildings +
                        " - " +
                        (absent.grades ? absent.grades : "")
                    }}
                  </div>
                  <v-divider
                    class="my-2"
                    v-if="index + 1 < existingDataForBus.absents.length"
                  ></v-divider>
                </div>
              </div>
            </div>
          </v-layout>
        </v-layout>
        <v-card-actions class="mr-0 pb-0 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="updateBusDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="saveBus">
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="deleteDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Delete Drivers</v-card-title>
        <div class="font-weight-regular">
          The {{ selected.length }} selected buses will be deleted
        </div>
        <v-card-actions class="mr-0 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="deleteDrivers">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="deleteBusDialog" max-width="900">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Delete Bus</v-card-title>

        <v-layout row>
          <v-layout column xs6 class="pr-2" style="min-width: 50%">
            <div
              class="pa-2 mb-2"
              style="border: #5cb860 1px solid; border-radius: 5px;"
            >
              <v-layout row class="mb-2">
                <div class="font-weight-medium mr-2 pt-2">
                  Bus Number:
                </div>
                <div class="pt-2">
                  {{ busToDelete.busNumber }}
                </div>
              </v-layout>
              <v-layout row class="mb-2">
                <div class="font-weight-medium mr-2">
                  Start Date:
                </div>
                <div>
                  {{ busToDelete.dateFrom }}
                </div> </v-layout
              ><v-layout row class="mb-2">
                <div class="font-weight-medium mr-2">
                  End Date:
                </div>
                <div>
                  {{ busToDelete.dateTo }}
                </div>
              </v-layout>
            </div>
          </v-layout>
          <v-layout column xs6 class="pl-2" style="min-width: 50%">
            <div v-if="getExistingDataForBusMessage(true)">
              <div class="text-danger font-weight-medium">
                {{ getExistingDataForBusMessage(true) }}
              </div>

              <div
                class="font-weight-medium title mt-3"
                v-if="
                  existingDataForBus.routeSchedules &&
                    existingDataForBus.routeSchedules.length
                "
              >
                Route Schedules
              </div>

              <div
                style="overflow-y: auto; height: 150px; border: 1px solid #4caf50; padding: 8px;"
                v-if="
                  existingDataForBus.routeSchedules &&
                    existingDataForBus.routeSchedules.length
                "
              >
                <div
                  v-for="(routeSchedule,
                  index) in existingDataForBus.routeSchedules"
                >
                  <div
                    class="font-weight-regular"
                    v-if="routeSchedule.route && routeSchedule.route.id"
                  >
                    {{ routeSchedule.route.routeIdentifier }}
                  </div>
                  <div
                    class="caption"
                    v-if="routeSchedule.route && routeSchedule.route.id"
                  >
                    {{
                      routeSchedule.route.timeStart +
                        " - " +
                        routeSchedule.route.buildings +
                        " - " +
                        (routeSchedule.route.grades
                          ? routeSchedule.route.grades
                          : "")
                    }}
                  </div>
                  <v-divider
                    class="my-2"
                    v-if="index + 1 < existingDataForBus.routeSchedules.length"
                  ></v-divider>
                </div>
              </div>
              <div
                class="font-weight-medium title mt-3"
                v-if="
                  existingDataForBus.absents &&
                    existingDataForBus.absents.length
                "
              >
                Absents
              </div>
              <div
                style="overflow-y: auto; height: 150px; border: 1px solid #4caf50; padding: 8px;"
                v-if="
                  existingDataForBus.absents &&
                    existingDataForBus.absents.length
                "
              >
                <div v-for="(absent, index) in existingDataForBus.absents">
                  <div class="font-weight-regular" v-if="absent.id">
                    {{ absent.date | date }}
                  </div>
                  <div class="caption" v-if="absent.id">
                    {{
                      absent.timeStart +
                        " - " +
                        absent.buildings +
                        " - " +
                        (absent.grades ? absent.grades : "")
                    }}
                  </div>
                  <v-divider
                    class="my-2"
                    v-if="index + 1 < existingDataForBus.absents.length"
                  ></v-divider>
                </div>
              </div>
            </div>
          </v-layout>
        </v-layout>

        <v-card-actions class="mr-0 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="deleteBusDialog = false"
            >Close</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            :disabled="!!getExistingDataForBusMessage(true)"
            @click="deleteBus"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Record Message Dialog -->
    <v-dialog persistent v-model="recordDialog" max-width="500">
      <v-card class="pa-3">
        <v-card-title class="headline px-0 pt-0">Record Message</v-card-title>
        <v-card-text class="pa-0">
          <div class="mb-3">
            Please call <strong>718-690-2308</strong> and enter the following
            PIN number:
          </div>
          <div class="text-center mb-3">
            <v-chip color="primary" text-color="white" large class="headline">
              {{ pinNumber }}
            </v-chip>
          </div>
          <div class="mb-2" v-if="!recordingUrl">
            Once you have completed the recording, click the button below to
            retrieve it.
          </div>
          <div v-if="recordingError" class="text-danger mb-2">
            {{ recordingError }}
          </div>
          <div v-if="recordingUrl" class="mb-3">
            <div class="mb-2 font-weight-medium">Recording found:</div>
            <audio controls :src="recordingUrl" style="width: 100%;"></audio>
          </div>
        </v-card-text>
        <v-card-actions class="mr-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="closeRecordDialog()"
            >Cancel</v-btn
          >
          <v-btn
            v-if="!recordingUrl"
            :loading="checkingRecording"
            color="success"
            @click="checkRecording()"
          >
            Recording Done
          </v-btn>
          <v-btn v-if="recordingUrl" color="success" @click="attachRecording()">
            Attach Recording
          </v-btn>
          <v-btn
            v-if="recordingUrl"
            color="primary"
            @click="retryRecording()"
            class="ml-2"
          >
            Retry
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Send Text Message Dialog -->
    <v-dialog persistent v-model="sendTextMessageDialog" max-width="1000">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0 pb-3"
          >Send Text Message</v-card-title
        >
        <v-card-text class="pa-0">
          <v-layout row>
            <!-- Left Section: Driver List + Additional Numbers -->
            <v-flex xs6 class="pr-3 mb-2">
              <div class="font-weight-medium mb-2">
                Selected Drivers ({{ selectedDriversForMessage.length }}):
              </div>
              <div
                style="overflow-y: auto; max-height: 350px; border: 1px solid #e0e0e0; padding: 12px; border-radius: 4px;"
              >
                <div
                  v-for="(driver, index) in selectedDriversForMessage"
                  :key="index"
                  class="mb-3"
                  :class="{
                    'pb-3': index < selectedDriversForMessage.length - 1,
                  }"
                  :style="
                    index < selectedDriversForMessage.length - 1
                      ? 'border-bottom: 1px solid #e0e0e0;'
                      : ''
                  "
                >
                  <div class="mb-1">
                    <span class="font-weight-medium">Name:</span>
                    {{ driver.name }}
                  </div>
                  <div class="mb-1">
                    <span class="font-weight-medium">Position:</span>
                    {{ driver.position || "N/A" }}
                  </div>
                  <div class="mb-1">
                    <span class="font-weight-medium">Bus Number:</span>
                    {{ driver.busNumbers || "N/A" }}
                  </div>
                  <div class="mb-1">
                    <span class="font-weight-medium">Phone Number:</span>
                    <span
                      v-if="driver.phoneNumber && driver.phoneNumber.trim()"
                    >
                      {{ driver.phoneNumber }}
                    </span>
                    <span v-else class="text-warning">
                      Message will not be sent to this person (no phone number)
                    </span>
                  </div>
                </div>
              </div>
            </v-flex>
            <!-- Right Section: Message Box and Buttons -->
            <v-flex xs6 class="pl-3">
              <div class="mb-2">
                <v-text-field
                  label="From Number"
                  value="866-660-9260"
                  disabled
                  outline
                  class="mb-3"
                  hide-details
                ></v-text-field>
                <div class="text-warning mb-1" v-if="showEnterNotice()">
                  To move to the next line use the "shift + enter" keys
                </div>
                <v-textarea
                  @keydown="onKeyDown"
                  outline
                  rows="6"
                  label="Message"
                  v-model="textMessage"
                  ref="textMessage"
                  :rules="[rules.required, rules.maxMessageLength]"
                  class="mb-0"
                ></v-textarea>
                <div class="mb-2">
                  <span class="mx-1 font-weight-medium">Character count:</span>
                  {{ getMessageCount(textMessage) }}
                </div>
                <v-layout row class="mt-2">
                  <v-btn
                    small
                    color="info"
                    class="mr-2 mt-0"
                    @click="openAudioLibraryDialog()"
                  >
                    <v-icon left dark>mdi-library-music</v-icon>
                    Audio Library
                  </v-btn>
                  <v-btn
                    small
                    color="success"
                    class="mt-0"
                    @click="openRecordDialog()"
                  >
                    <v-icon left dark>mdi-microphone</v-icon>
                    Record Message
                  </v-btn>
                </v-layout>
                <div v-if="audioFile" class="mt-2">
                  <div class="caption grey--text mb-1">Selected Audio:</div>
                  <v-layout row align-center>
                    <audio
                      controls
                      :src="audioFile"
                      style="width: 100%; max-width: 380px;"
                    ></audio>
                    <v-btn icon small @click="removeAudioFile()" class="ml-2">
                      <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
              </div>
              <v-card-actions class="pr-0 mr-0 pa-0 mt-3">
                <v-spacer></v-spacer>
                <v-btn
                  color="default"
                  dark
                  @click="closeSendTextMessageDialog()"
                  >Cancel</v-btn
                >
                <v-btn
                  :loading="sendingMessage"
                  color="success"
                  @click="sendTextMessage"
                >
                  Send Message
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Audio Library Dialog -->
    <v-dialog persistent v-model="audioLibraryDialog" max-width="1000">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0 pb-2"
          >Audio Library</v-card-title
        >
        <v-layout row class="mb-3" align-center wrap>
          <div class="subtitle-2 font-weight-medium mr-3">
            Files ({{ audioLibraryFiltered.length }})
          </div>
          <v-text-field
            style="max-width: 210px;"
            label="Search"
            v-model="audioLibrarySearch"
            hide-details
            clearable
            class="mr-2 mt-0"
            @input="onAudioLibrarySearch()"
          ></v-text-field>
          <v-menu
            v-model="audioLibraryFromDateMenu"
            :close-on-content-click="true"
            offset-y
            full-width
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="audioLibraryFromDate"
                label="From Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                class="mr-2 mt-0"
                style="max-width: 180px"
                hide-details
                clearable
                @click:clear="audioLibraryFromDateCleared()"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="audioLibraryFromDate"
              @change="onAudioLibraryFromDateChanged()"
            ></v-date-picker>
          </v-menu>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="success"
            class="mr-2 mt-0"
            :loading="audioLibraryUploading"
            @click="pickAudioLibraryFile()"
          >
            <v-icon left dark>mdi-cloud-upload</v-icon>
            Upload
          </v-btn>
          <v-btn
            small
            color="success"
            class="mt-0"
            :loading="loadingAudioLibrary"
            @click="loadAudioLibraryForDialog()"
          >
            <v-icon left dark>mdi-reload</v-icon>
            Reload
          </v-btn>
          <input
            type="file"
            style="display: none"
            ref="audioLibraryFile"
            accept=".mp3,.wav,audio/*"
            @change="onAudioLibraryFilePicked($event)"
          />
        </v-layout>

        <div style="height: 460px; overflow-y: auto;">
          <v-layout
            v-if="loadingAudioLibrary"
            justify-center
            align-center
            style="height: 100%;"
          >
            <v-progress-circular
              indeterminate
              color="success"
            ></v-progress-circular>
          </v-layout>
          <div v-else>
            <v-layout
              row
              class="pa-2 mb-2"
              align-center
              v-for="audio in audioLibraryPaginated"
              :key="audio.id"
              style="border: 1px solid #4caf50; border-radius: 4px;"
            >
              <!-- Info block -->
              <v-layout
                column
                class="mr-2"
                style="flex: 1; min-width: 0; overflow: hidden;"
              >
                <div class="mb-1" style="min-width: 0;">
                  <template v-if="!audio.editing">
                    <span
                      class="font-weight-medium body-2"
                      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 220px; display: inline-block; vertical-align: middle;"
                      >{{ audio.name || "Unnamed" }}</span
                    >
                    <v-icon
                      style="cursor: pointer; color: #bdbdbd; vertical-align: middle; margin-left: 4px; font-size: 13px;"
                      @click.stop="editAudioLibraryName(audio)"
                      >mdi-pencil</v-icon
                    >
                  </template>
                  <template v-else>
                    <div
                      style="display: inline-flex; align-items: center; border: 1px solid #4caf50; border-radius: 4px; padding: 1px 4px; background: #fff;"
                      @click.stop
                    >
                      <input
                        v-model="audio.name"
                        style="border: none; outline: none; font-size: 14px; width: 210px; background: transparent;"
                        @click.stop
                        @keyup.enter.stop="saveAudioLibraryName(audio)"
                        @keyup.esc.stop="cancelAudioLibraryName(audio)"
                      />
                      <v-icon
                        small
                        style="cursor: pointer; color: #9e9e9e; margin-left: 4px;"
                        @click.stop="cancelAudioLibraryName(audio)"
                        title="Cancel"
                        >mdi-close</v-icon
                      >
                      <v-icon
                        small
                        style="cursor: pointer; color: #4caf50; margin-left: 2px;"
                        @click.stop="saveAudioLibraryName(audio)"
                        title="Save"
                        >mdi-check</v-icon
                      >
                    </div>
                  </template>
                </div>
                <div class="caption grey--text mb-1">
                  <span class="mr-2">{{ formatAudioDate(audio.date) }}</span>
                  <span v-if="audio.source" class="mr-2">
                    <v-icon x-small style="vertical-align: middle;"
                      >mdi-music-circle-outline</v-icon
                    >
                    {{ audio.source }}
                  </span>
                </div>
                <div class="caption grey--text">
                  <span v-if="audio.callerID" class="mr-2">
                    <v-icon x-small style="vertical-align: middle;"
                      >mdi-phone</v-icon
                    >
                    {{ formatPhone(audio.callerID) }}
                  </span>
                  <span v-if="audio.user" class="mr-2">
                    <v-icon x-small style="vertical-align: middle;"
                      >mdi-account</v-icon
                    >
                    {{ audio.user }}
                  </span>
                  <span
                    v-if="audio.branch"
                    class="d-inline-block"
                    style="max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: middle;"
                    :title="audio.branch"
                  >
                    <v-icon x-small style="vertical-align: middle;"
                      >mdi-source-branch</v-icon
                    >
                    {{ audio.branch }}
                  </span>
                </div>
              </v-layout>
              <!-- Player + actions -->
              <audio
                controls
                :src="audio.recordingURL"
                class="mr-2"
                style="height: 36px; flex-shrink: 0;"
              ></audio>
              <v-btn
                small
                color="success"
                class="mr-1 mt-0"
                style="flex-shrink: 0;"
                @click="selectAudioFromLibrary(audio)"
              >
                Select
              </v-btn>
              <v-btn
                icon
                small
                class="mt-0"
                style="flex-shrink: 0;"
                @click="openDeleteAudioLibraryItem(audio)"
              >
                <v-icon color="error" small>mdi-delete</v-icon>
              </v-btn>
            </v-layout>
            <div
              v-if="!audioLibraryPaginated.length && !loadingAudioLibrary"
              class="text-center grey--text pa-6"
            >
              No audio files found
            </div>
          </div>
        </div>

        <v-layout justify-center class="mt-2">
          <v-pagination
            v-model="audioLibraryPagination.page"
            :length="audioLibraryPages()"
            :total-visible="7"
            @input="setAudioLibraryPage()"
          ></v-pagination>
        </v-layout>

        <v-card-actions class="pr-0 pb-0 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="audioLibraryDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Audio from Library confirm dialog -->
    <v-dialog persistent v-model="audioLibraryDeleteDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Delete Audio</v-card-title>
        <v-card-text class="py-2">
          You will delete
          <strong>{{
            audioLibraryToDelete && audioLibraryToDelete.name
          }}</strong
          >. This cannot be undone.
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="audioLibraryDeleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="audioLibraryDeleting"
            color="error"
            @click="deleteAudioLibraryItem()"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";

export default {
  data: () => ({
    title: "Drivers",

    actions: [],

    updateDriverDialog: false,
    addNewDriverDialog: false,
    deactivateBusDialog: false,
    sendTextMessageDialog: false,
    selectedDriversForMessage: [],
    textMessage: "",
    sendingMessage: false,
    audioFile: null,
    uploadingAudio: false,
    selectedLibraryAudioID: null,
    audioLibraryDialog: false,
    audioLibraryAll: [],
    audioLibraryFiltered: [],
    audioLibraryPaginated: [],
    audioLibrarySearch: "",
    audioLibraryFromDate: "",
    audioLibraryFromDateMenu: false,
    audioLibraryPagination: { page: 1, rowsPerPage: 8 },
    loadingAudioLibrary: false,
    audioLibraryUploading: false,
    audioLibraryDeleteDialog: false,
    audioLibraryToDelete: null,
    audioLibraryDeleting: false,
    recordDialog: false,
    pinNumber: "",
    checkingRecording: false,
    recordingUrl: null,
    recordingError: null,

    rowClicked: {
      id: "",
      name: "",
      nameHeb: "",
      employeeID: "",
      employee: "",
      buses: [],
    },

    newDriver: {
      id: "",
      name: "",
      nameHeb: "",
      buses: [
        {
          busNumber: "",
          datePickerMenuFrom: false,
          dateFrom: "",
          datePickerMenuTo: false,
          dateTo: "",
        },
      ],
    },

    processing: false,
    deleteDialog: false,
    deleting: false,
    selected: [],
    files: [],
    url: "",
    employeeList: [],
    employees: [],
    employees2: [],
    loadEmployeeSearch: null,
    loadClickedEmployeeSearch: null,
    loadClickedBusesSearch: null,
    selectedEmployee: "",
    clickedEmployee: "",

    clickedBuses: "",
    buses: [],
    busList: [],

    driverBuses: [],

    updateBusDialog: false,
    existingDataForBus: {},
    routes: [],
    deleteBusDialog: false,
    busToDelete: {},

    rules: {
      required: (value) => !!value || "Required.",
      busNumberRequired: (value, bus) => {
        return !bus.dateFrom || !bus.dateFrom || !!value || "Required.";
      },
      phoneNumber: (v) => {
        return (
          !v ||
          ([10, 11].includes(v.replace(/-/g, "").length) &&
            /^\d+$/.test(v.replace(/-/g, ""))) ||
          "Invalid Phone Number"
        );
      },
      maxMessageLength: (value) => {
        if (!value) return true;
        let count = 0;
        for (let i = 0; i < value.length; i++) {
          let code = value.charCodeAt(i);
          if (code < 128) {
            count++;
          } else if (code < 2048) {
            count += 2;
          } else if (code < 65536) {
            count += 3;
          } else {
            count += 4;
          }
        }
        return count < 738 || "Max length is 737";
      },
    },

    columns: [
      // {
      //     label: "ID",
      //     field: "id",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      // {
      //     label: "Hebrew Name",
      //     field: "nameH",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
      // {
      //     label: "Phone Number",
      //     field: "phoneNumber",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
      {
        label: "Position",
        field: "position",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        sortIndex: 0,
        sortOrder: "asc",
      },
      {
        label: "Employee ID",
        field: "employeeID",
        visible: true,
        type: "number",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Buses",
        field: "buses",
        visible: true,
        type: "number",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Bus Number",
        field: "busNumbers",
        visible: true,
        sortOrder: "asc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      // {
      //     label: "Date Added",
      //     field: "dateAdded",
      //     visible: true,
      //     type: "date",
      //     format: "MM/dd/yyyy hh:mm:ss a",
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
    ],
  }),
  watch: {
    loadEmployeeSearch(value) {
      if (!value) return;
      if (!this.employeeList.length) return;

      this.employees = this.employeeList.filter((b) =>
        b.displayName.toUpperCase().includes(value.toUpperCase())
      );
    },
    loadClickedEmployeeSearch(value) {
      if (!value) return;
      if (!this.employeeList.length) return;

      this.employees2 = this.employeeList.filter((b) =>
        b.displayName.toUpperCase().includes(value.toUpperCase())
      );
    },
    loadClickedBusesSearch(value) {
      if (!value) return;
      if (!this.busList.length) return;

      this.buses = this.busList.filter((b) =>
        b.busNumber.toUpperCase().includes(value.toUpperCase())
      );
    },
  },
  mounted() {},
  beforeDestroy() {},
  async created() {
    this.loadEmployees();
    this.loadBuses();
    this.loadRoutes();
  },
  methods: {
    async beforeSetupGrid() {
      // this.actions.push({
      //     text: "Delete Drivers",
      //     action: this.openDeleteDriversDialog,
      //     showOnSelection: true,
      // });

      // this.actions.push({
      //     text: "Add Driver",
      //     action: this.addBusDriver,
      // });

      this.actions.push({
        text: "Send Text Message",
        action: this.openSendTextMessageDialog,
        showOnSelection: true,
      });

      this.url = "drivers";
    },
    async loadEmployees() {
      const response = await this.$http.get(
        "api/drivers/GetBusesDriverEmployees"
      );

      this.employeeList = response.map((employee) => {
        employee.displayName =
          employee.employeeID +
          " - " +
          (employee.teacherH ? employee.teacherH : employee.teacher);

        return employee;
      });
    },
    async loadBuses() {
      const response = await this.$http.get("api/drivers/GetBuses");

      this.busList = response.sort(
        (a, b) => parseInt(a.busNumber) - parseInt(b.busNumber)
      );
    },
    async loadRoutes() {
      const response = await this.$http.get(
        "odata/route?regID=&filterByToday=&season=&routeKind="
      );

      this.routes = response.value;
    },
    onEmployeeSelected(value) {
      const employee = this.employeeList.find((e) => e.displayName == value);

      if (!employee) return;

      this.newDriver.nameHeb = employee.teacherH;
      this.newDriver.name = employee.teacher;
    },
    onClickedEmployeeSelected(value) {
      const employee = this.employeeList.find((e) => e.displayName == value);

      if (!employee) return;

      this.rowClicked.nameHeb = employee.teacherH;
      this.rowClicked.name = employee.teacher;
    },
    addBus() {
      if (this.addNewDriverDialog) {
        this.newDriver.buses.push({
          busNumber: "",
          datePickerMenuFrom: false,
          dateFrom: "",
          datePickerMenuTo: false,
          dateTo: "",
        });
      } else {
        this.rowClicked.buses.push({
          busNumber: "",
          datePickerMenuFrom: false,
          dateFrom: "",
          datePickerMenuTo: false,
          dateTo: "",
          editing: false,
        });
      }

      this.$forceUpdate();
    },
    removeBus(index) {
      if (this.addNewDriverDialog) {
        this.newDriver.buses.splice(index, 1);

        this.$forceUpdate();

        return;
      }

      if (index == 0) {
        this.rowClicked.buses[index].busID = "";
        this.rowClicked.buses[index].busNumber = "";
        this.rowClicked.buses[index].dateFrom = "";
        this.rowClicked.buses[index].dateTo = "";
      } else {
        this.rowClicked.buses.splice(index, 1);
      }

      this.$forceUpdate();
    },
    maxFromDate(bus) {
      if (!bus.dateTo)
        return moment(new Date(8640000000000000)).format("YYYY-MM-DD");

      const dateTo = new Date(bus.dateTo);

      return new Date(dateTo);
    },
    minToDate(bus) {
      if (!bus.dateFrom)
        return moment(new Date(-8640000000000000)).format("YYYY-MM-DD");

      const dateFrom = new Date(bus.dateFrom);

      return new Date(dateFrom);
    },
    formatedDate(date) {
      return date ? moment(date).format("L") : "";
    },
    getEmployeeID(value) {
      if (!value) return;

      const id = value.split("-")[0].trim();

      const employee = this.employeeList.find((e) => e.employeeID == id);

      return employee ? employee.employeeID : null;
    },
    getEmployeeByID(employeeID) {
      if (!employeeID) return;

      const employee = this.employeeList.find(
        (e) => e.employeeID == employeeID
      );

      return employee ? employee.displayName : null;
    },
    validateNewDriver() {
      const validations = [
        this.$refs.newName.validate(true),
        this.$refs.newNameHeb.validate(true),
      ];

      this.$refs.newBusNumber.map((busNumber) => {
        validations.push(busNumber.validate(true));
      });

      return validations.every(Boolean);
    },
    async saveNewDriver() {
      if (!this.validateNewDriver()) return;

      if (
        this.newDriver.buses.some(
          (bus) =>
            bus.dateFrom &&
            bus.dateTo &&
            new Date(bus.dateFrom) > new Date(bus.dateTo)
        )
      ) {
        return this.$notify({
          text: "From Date is later than the To Date",
          group: "notification",
          type: "error",
        });
      }

      const driverBusList = this.newDriver.buses
        .filter((b) => b.busNumber)
        .map((bus) => {
          const busData = this.busList.find(
            (b) => b.busNumber == bus.busNumber
          );

          return {
            driverID: 0,
            busID: busData.id,
            dateFrom: moment(bus.dateFrom).format("L"),
            dateTo: moment(bus.dateTo).format("L"),
          };
        });

      try {
        this.processing = true;

        await this.$http.post("api/drivers/save", {
          driver: {
            name: this.newDriver.name,
            nameHeb: this.newDriver.nameHeb,
            employeeID: this.getEmployeeID(this.selectedEmployee),
          },
          driverBusList,
        });

        this.processing = false;
        this.addNewDriverDialog = false;

        this.newDriver.name = "";
        this.newDriver.nameHeb = "";
        this.selectedEmployee = "";
        this.employees = [];

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    async onRowClicked(row) {
      this.rowClicked = JSON.parse(JSON.stringify(row));

      this.loadBusesForDriver();

      this.updateDriverDialog = true;
    },
    async loadBusesForDriver() {
      const response = await this.$http.get(
        "api/drivers/getDriverBuses?employeeID=" + this.rowClicked.employeeID
      );

      this.rowClicked.buses = response.map((driverBus) => {
        const bus = this.busList.find((b) => b.id == driverBus.busID);

        return {
          id: driverBus.id,
          busNumber: bus.busNumber,
          datePickerMenuFrom: false,
          editing: false,
          dateFrom: driverBus.dateFrom
            ? moment(driverBus.dateFrom).format("YYYY-MM-DD")
            : "",
          datePickerMenuTo: false,
          dateTo: driverBus.dateTo
            ? moment(driverBus.dateTo).format("YYYY-MM-DD")
            : "",
          isArchived: driverBus.isArchived,
        };
      });

      this.rowClicked.newBusNumber = "";
    },
    addBusDriver() {
      this.addNewDriverDialog = true;
    },
    openDeleteDriversDialog() {
      this.selected = this.$refs.grid.getSelectedRowsData();

      this.deleteDialog = true;
    },
    async openDeleteBus(bus) {
      this.busToDelete = bus;

      this.existingDataForBus = await this.$http.get(
        "api/drivers/getRoutesAndAbsentsForDriver?driverBusID=" +
          this.busToDelete.id
      );

      this.existingDataForBus.routeSchedules.forEach((routeSchedule) => {
        const route = this.routes.find((r) => r.id == routeSchedule.route_ID);

        routeSchedule.route = route;
      });

      if (
        !this.existingDataForBus.routeSchedules.length &&
        !this.existingDataForBus.absents.length
      ) {
        this.existingDataForBus = null;
      }

      this.deleteBusDialog = true;
    },
    async deleteBus() {
      try {
        this.processing = true;

        await this.$http.post(
          "api/drivers/DeleteDriverBus?id=" + this.busToDelete.id
        );

        this.deleteBusDialog = false;

        this.processing = false;

        this.loadBusesForDriver();

        this.$notify({
          group: "notification",
          text: "Bus Deleted",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    getActiveBuses() {
      if (!this.rowClicked) return [];
      if (!this.rowClicked.buses) return [];
      if (!this.rowClicked.buses.length) return [];

      return this.rowClicked.buses.filter((b) => !b.isArchived);
    },
    async openUpdateBus() {
      this.existingDataForBus = {};

      let activeBuses = [];

      if (this.rowClicked.buses && this.rowClicked.buses.length) {
        activeBuses = this.rowClicked.buses.filter((b) => !b.isArchived);
      }

      if (activeBuses.length) {
        const driverBusID = activeBuses[0].id;
        this.existingDataForBus = await this.$http.get(
          "api/drivers/getRoutesAndAbsentsForDriver?driverBusID=" + driverBusID
        );

        this.existingDataForBus.routeSchedules.forEach((routeSchedule) => {
          const route = this.routes.find((r) => r.id == routeSchedule.route_ID);

          routeSchedule.route = route;
        });
      }

      this.$refs.newBusNumber.resetValidation();

      this.updateBusDialog = true;
    },
    async openDeactivateDriver() {
      const busToDeactivate = this.getActiveBuses()[0];

      this.existingDataForBus = await this.$http.get(
        "api/drivers/getRoutesAndAbsentsForDriver?driverBusID=" +
          busToDeactivate.id
      );

      this.existingDataForBus.routeSchedules.forEach((routeSchedule) => {
        const route = this.routes.find((r) => r.id == routeSchedule.route_ID);

        routeSchedule.route = route;
      });

      if (
        !this.existingDataForBus.routeSchedules.length &&
        !this.existingDataForBus.absents.length
      ) {
        this.existingDataForBus = null;
      }

      this.deactivateBusDialog = true;
    },
    async deactivateDriver() {
      try {
        const busToDeactivate = this.getActiveBuses()[0];

        this.processing = true;

        await this.$http.post("api/drivers/deactivateDriverBus", {
          employeeID: this.rowClicked.employeeID,
          currentDriverBusID: busToDeactivate.id,
          newBusID: null,
        });

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.processing = false;
        this.updateDriverDialog = false;
        this.deactivateBusDialog = false;

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    getExistingDataForBusMessage(isDeleting = false) {
      if (!this.existingDataForBus) return;
      if (!this.existingDataForBus.routeSchedules) return;
      if (!this.existingDataForBus.absents) return;

      const hasExistingData =
        this.existingDataForBus.routeSchedules.length ||
        this.existingDataForBus.absents.length;

      if (!hasExistingData) return;

      let text = "We found ";

      if (this.existingDataForBus.routeSchedules.length) {
        text += "route schedules ";
      }

      if (
        this.existingDataForBus.routeSchedules.length &&
        this.existingDataForBus.absents.length
      ) {
        text += "and ";
      }

      if (this.existingDataForBus.absents.length) {
        text += "absent reports for bus: " + this.rowClicked.buses[0].busNumber;
      }

      text += isDeleting
        ? ". Please delete them first."
        : ". This will be updated to the new bus number.";

      return text;
    },
    async saveBus() {
      if (!this.$refs.newBusNumber.validate(true)) return;

      try {
        this.processing = true;

        const bus = this.busList.find(
          (b) => b.busNumber == this.rowClicked.newBusNumber
        );

        await this.$http.post("api/drivers/saveDriverBus", {
          employeeID: this.rowClicked.employeeID,
          currentDriverBusID: this.rowClicked.buses.filter((b) => !b.isArchived)
            .length
            ? this.rowClicked.buses.filter((b) => !b.isArchived)[0].id
            : null,
          newBusID: bus.id,
        });

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.processing = false;
        this.updateDriverDialog = false;
        this.updateBusDialog = false;

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    validate() {
      const validations = [];

      this.$refs.busNumber.map((busNumber) => {
        validations.push(busNumber.validate(true));
      });

      return validations.every(Boolean);
    },
    async saveDriver() {
      if (!this.validate()) return;

      if (
        this.rowClicked.buses.some(
          (bus) => new Date(bus.dateFrom) > new Date(bus.dateTo)
        )
      ) {
        return this.$notify({
          text: "From Date is later than the To Date",
          group: "notification",
          type: "error",
        });
      }

      const driverBusList = this.rowClicked.buses
        .filter((b) => b.busNumber)
        .map((bus) => {
          const busData = this.busList.find(
            (b) => b.busNumber == bus.busNumber
          );

          return {
            id: bus.id,
            employeeID: this.rowClicked.employeeID,
            busID: busData.id,
            dateFrom: bus.dateFrom ? moment(bus.dateFrom).format("L") : "",
            dateTo: bus.dateTo ? moment(bus.dateTo).format("L") : "",
          };
        });

      try {
        this.processing = true;

        await this.$http.post("api/drivers/save", {
          employeeID: this.rowClicked.employeeID,
          driverBusList,
        });

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.processing = false;
        this.updateDriverDialog = false;

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    async deleteDrivers() {
      try {
        const ids = this.selected.map((s) => s.id);

        this.processing = true;

        await this.$http.post("api/drivers/delete", ids);

        this.processing = false;
        this.deleteDialog = false;

        this.$notify({
          group: "notification",
          text: ids.length + " Buses Deleted",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    async openSendTextMessageDialog() {
      const selected = this.$refs.grid.getSelectedRowsData();

      // Enrich selected drivers with phone numbers from employee list
      this.selectedDriversForMessage = selected.map((driver) => {
        const employee = this.employeeList.find(
          (e) => e.employeeID == driver.employeeID
        );
        return {
          ...driver,
          phoneNumber:
            driver.phoneNumber || (employee ? employee.phoneNumber : null),
        };
      });

      this.textMessage = "";
      this.audioFile = null;
      this.selectedLibraryAudioID = null;
      this.sendTextMessageDialog = true;
    },
    getMessageCount(value) {
      if (!value) return 0;

      let count = 0;
      for (let i = 0; i < value.length; i++) {
        let code = value.charCodeAt(i);
        if (code < 128) {
          count++;
        } else if (code < 2048) {
          count += 2;
        } else if (code < 65536) {
          count += 3;
        } else {
          count += 4;
        }
      }

      return count;
    },
    showEnterNotice() {
      const users = [
        "12561@utaw.org",
        "256@utaw.org",
        "258@utaw.org",
        "257@utaw.org",
        "jwercberger@utaw.org",
      ];

      return users.includes(this.$store.state.authentication.user);
    },
    onKeyDown(event) {
      const users = [
        "12561@utaw.org",
        "256@utaw.org",
        "257@utaw.org",
        "258@utaw.org",
        "jwercberger@utaw.org",
      ];

      if (users.includes(this.$store.state.authentication.user)) {
        if (event.keyCode === 13 && event.shiftKey) {
          // Shift+Enter must insert a new line: keep the default action,
          // but don't let the key bubble up, where it was being treated
          // like a plain Enter and threw the user out to the dashboard.
          event.stopPropagation();
        } else if (event.keyCode === 13) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    },
    async sendTextMessage() {
      if (this.$refs.textMessage && !this.$refs.textMessage.validate(true))
        return;

      if (!this.textMessage) {
        this.$notify({
          text: "Message Required",
          group: "notification",
          type: "error",
        });
        return;
      }

      try {
        this.sendingMessage = true;

        // Filter drivers with phone numbers and create numbers array
        const numbers = this.selectedDriversForMessage
          .filter(
            (driver) => driver.phoneNumber && driver.phoneNumber.trim() !== ""
          )
          .map((driver) => {
            const phoneNumber = driver.phoneNumber.replace(/-/g, "");
            return {
              accountID: driver.employeeID || driver.id,
              number: phoneNumber,
            };
          });

        if (numbers.length === 0) {
          this.$notify({
            text: "No drivers with phone numbers selected",
            group: "notification",
            type: "error",
          });
          this.sendingMessage = false;
          return;
        }

        const isLocalhost =
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1";
        const url = isLocalhost
          ? "https://localhost:7197/broadcast/broadcastMessage"
          : "https://broadcast-3t6ck5zrrq-ue.a.run.app/broadcast/broadcastMessage";

        await this.$http.post(url, {
          from: "18666609260",
          broadcastID: null,
          user: this.$store.state.authentication.user,
          types: [],
          attachmentRecording: this.audioFile || null,
          audioID: this.selectedLibraryAudioID,
          text: this.textMessage,
          broadcastName: "Driver_Text_Message_" + moment().format("MM_DD_YYYY"),
          confirmListing: false,
          repeat: 2,
          isTest: false,
          testNumber: "",
          requestID: 0,
          isMenahalBroadcast: true,
          numbers: numbers,
          branch: "BUS - באס",
          grade: "",
          numberSelectionMode: "manualEntry",
          accountsSource: "TUITION",
          broadcastTime: null,
        });

        this.$notify({
          text: "Text message sent successfully",
          group: "notification",
          type: "success",
        });

        this.sendTextMessageDialog = false;
        this.textMessage = "";
        this.selectedDriversForMessage = [];
        this.audioFile = null;
        this.selectedLibraryAudioID = null;
      } catch (e) {
        this.$notify({
          text: "Failed to send text message",
          group: "notification",
          type: "error",
        });
      } finally {
        this.sendingMessage = false;
      }
    },
    closeSendTextMessageDialog() {
      this.sendTextMessageDialog = false;
      this.textMessage = "";
      this.selectedDriversForMessage = [];
      this.audioFile = null;
      this.selectedLibraryAudioID = null;
    },
    removeAudioFile() {
      this.audioFile = null;
      this.selectedLibraryAudioID = null;
    },
    formatPhone(phone) {
      if (!phone) return "";
      const cleaned = phone.replace(/\D/g, "");
      if (cleaned.length === 11) {
        return (
          "+1 (" +
          cleaned.substring(1, 4) +
          ") " +
          cleaned.substring(4, 7) +
          "-" +
          cleaned.substring(7)
        );
      } else if (cleaned.length === 10) {
        return (
          "(" +
          cleaned.substring(0, 3) +
          ") " +
          cleaned.substring(3, 6) +
          "-" +
          cleaned.substring(6)
        );
      }
      return phone;
    },
    formatAudioDate(date) {
      if (!date) return "";
      return moment(date).format("MM/DD/YY h:mm A");
    },
    openAudioLibraryDialog() {
      this.audioLibrarySearch = "";
      this.audioLibraryFromDate = "";
      this.audioLibraryPagination.page = 1;
      this.audioLibraryDialog = true;
      this.loadAudioLibraryForDialog();
    },
    async loadAudioLibraryForDialog() {
      this.loadingAudioLibrary = true;

      try {
        const response = await this.$http.get("api/broadcast/getAudioLibrary");

        this.audioLibraryAll = (response || [])
          .map((audio) => {
            audio.name = audio.name ? audio.name : "Unnamed";
            audio.editing = false;
            audio.originalName = audio.name;
            return audio;
          })
          .filter((audio) => {
            const userBranch = this.$store.state.authentication.branch;
            if (userBranch && !userBranch.includes("null")) {
              const branches = userBranch.split(",");
              const audioBranches = audio.branch ? audio.branch.split(",") : [];
              return (
                audio.branch &&
                (branches.some((b) => b == audio.branch) ||
                  audioBranches.some((ab) => branches.some((br) => br == ab)))
              );
            }
            return true;
          });

        this.audioLibraryFiltered = this.audioLibraryAll;
        this.setAudioLibraryPage();
      } catch (e) {
        this.$notify({
          text: "Failed to load audio library",
          group: "notification",
          type: "error",
        });
      } finally {
        this.loadingAudioLibrary = false;
      }
    },
    onAudioLibrarySearch() {
      const search =
        this.audioLibrarySearch && this.audioLibrarySearch.toLowerCase();
      let filtered = this.audioLibraryAll;

      if (search) {
        filtered = filtered.filter(
          (a) => a.name && a.name.toLowerCase().includes(search)
        );
      }

      if (this.audioLibraryFromDate) {
        const fromDate = new Date(this.audioLibraryFromDate);
        filtered = filtered.filter((a) => new Date(a.date) >= fromDate);
      }

      this.audioLibraryFiltered = filtered;
      this.audioLibraryPagination.page = 1;
      this.setAudioLibraryPage();
    },
    onAudioLibraryFromDateChanged() {
      this.onAudioLibrarySearch();
    },
    audioLibraryFromDateCleared() {
      this.audioLibraryFromDate = "";
      this.onAudioLibrarySearch();
    },
    audioLibraryPages() {
      if (!this.audioLibraryPagination.rowsPerPage) return 0;
      return Math.ceil(
        this.audioLibraryFiltered.length /
          this.audioLibraryPagination.rowsPerPage
      );
    },
    setAudioLibraryPage() {
      const start =
        (this.audioLibraryPagination.page - 1) *
        this.audioLibraryPagination.rowsPerPage;
      this.audioLibraryPaginated = this.audioLibraryFiltered.slice(
        start,
        start + this.audioLibraryPagination.rowsPerPage
      );
    },
    editAudioLibraryName(audio) {
      audio.originalName = audio.name;
      audio.editing = true;
    },
    cancelAudioLibraryName(audio) {
      audio.name = audio.originalName ? audio.originalName : audio.name;
      audio.editing = false;
    },
    async saveAudioLibraryName(audio) {
      const updatedName = audio.name && audio.name.trim();
      if (!updatedName) {
        this.$notify({
          text: "Audio name cannot be empty",
          group: "notification",
          type: "error",
        });
        return;
      }

      try {
        await this.$http.post(
          "api/broadcast/updateAudioName?id=" +
            audio.id +
            "&name=" +
            encodeURIComponent(updatedName)
        );
        audio.name = updatedName;
        audio.originalName = updatedName;
        audio.editing = false;
        this.$notify({
          text: "Audio name updated",
          group: "notification",
          type: "success",
        });
      } catch (e) {
        audio.name = audio.originalName ? audio.originalName : audio.name;
        audio.editing = false;
        this.$notify({
          text: "Failed to update audio name",
          group: "notification",
          type: "error",
        });
      }
    },
    pickAudioLibraryFile() {
      this.$refs.audioLibraryFile.click();
    },
    async onAudioLibraryFilePicked(e) {
      if (!e.target.files || !e.target.files.length) return;

      const file = e.target.files[0];

      this.audioLibraryUploading = true;

      try {
        const formData = new FormData();
        formData.append("upload_file", file);

        const response = await this.$http.post(
          "api/broadcast/uploadAudioFile?user=" +
            this.$store.state.authentication.user,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        this.$notify({
          text: "Audio file uploaded successfully",
          group: "notification",
          type: "success",
        });

        await this.loadAudioLibraryForDialog();

        if (response && response.audio) {
          this.selectAudioFromLibrary(response.audio);
        }
      } catch (e) {
        this.$notify({
          text: "Failed to upload audio file",
          group: "notification",
          type: "error",
        });
      } finally {
        this.audioLibraryUploading = false;
        if (this.$refs.audioLibraryFile) {
          this.$refs.audioLibraryFile.value = "";
        }
      }
    },
    selectAudioFromLibrary(audio) {
      this.audioFile = audio.recordingURL;
      this.selectedLibraryAudioID = audio.id;
      this.audioLibraryDialog = false;
      this.$notify({
        text: "Audio selected: " + audio.name,
        group: "notification",
        type: "success",
      });
    },
    openDeleteAudioLibraryItem(audio) {
      this.audioLibraryToDelete = audio;
      this.audioLibraryDeleteDialog = true;
    },
    async deleteAudioLibraryItem() {
      this.audioLibraryDeleting = true;

      try {
        await this.$http.post(
          "api/broadcast/deleteAudio?id=" + this.audioLibraryToDelete.id
        );

        this.audioLibraryDeleteDialog = false;

        this.$notify({
          text: "Audio deleted",
          group: "notification",
          type: "success",
        });

        await this.loadAudioLibraryForDialog();
      } catch (e) {
        this.$notify({
          text: "Failed to delete audio",
          group: "notification",
          type: "error",
        });
      } finally {
        this.audioLibraryDeleting = false;
      }
    },
    async openRecordDialog() {
      this.recordDialog = true;
      this.pinNumber = "";
      this.recordingUrl = null;
      this.recordingError = null;

      try {
        const user = this.$store.state.authentication.user;
        const pin = await this.$http.post(
          `api/broadcast/GenerateRecordingPin?user=${user}`
        );
        this.pinNumber = pin;
      } catch (e) {
        this.$notify({
          text: "Failed to generate PIN number",
          group: "notification",
          type: "error",
        });
        this.recordDialog = false;
      }
    },
    closeRecordDialog() {
      this.recordDialog = false;
      this.pinNumber = "";
      this.recordingUrl = null;
      this.recordingError = null;
    },
    async checkRecording() {
      if (!this.pinNumber) {
        this.recordingError = "PIN number is required";
        return;
      }

      this.checkingRecording = true;
      this.recordingError = null;

      try {
        const response = await this.$http.get(
          `api/broadcast/GetRecording?pin=${this.pinNumber}`
        );

        // API returns { recording: "url", ... }
        if (response && response.recording) {
          // Convert recording to MP3
          const convertedUrl = await this.convertToMp3(response.recording);
          this.recordingUrl = convertedUrl;
          this.$notify({
            text: "Recording retrieved successfully",
            group: "notification",
            type: "success",
          });
          // Keep dialog open so user can preview the recording
        } else {
          this.recordingError =
            "Recording not found. Please make sure you completed the call and entered the correct PIN.";
        }
      } catch (e) {
        this.recordingError =
          "Recording not found. Please make sure you completed the call and entered the correct PIN.";
      } finally {
        this.checkingRecording = false;
      }
    },
    attachRecording() {
      if (this.recordingUrl) {
        this.audioFile = this.recordingUrl;
        this.selectedLibraryAudioID = null;
        this.closeRecordDialog();
        this.$notify({
          text: "Recording attached to message",
          group: "notification",
          type: "success",
        });
      }
    },
    async retryRecording() {
      // Reset and generate new PIN
      this.recordingUrl = null;
      this.recordingError = null;
      this.pinNumber = "";

      try {
        const user = this.$store.state.authentication.user;
        const pin = await this.$http.post(
          `api/broadcast/GenerateRecordingPin?user=${user}`
        );
        this.pinNumber = pin;
        this.$notify({
          text: "New PIN generated. Please call again with the new PIN.",
          group: "notification",
          type: "info",
        });
      } catch (e) {
        this.$notify({
          text: "Failed to generate new PIN number",
          group: "notification",
          type: "error",
        });
      }
    },
    async convertToMp3(url) {
      try {
        const response = await this.$http.post(
          `api/adminportal/ConvertToMp3?url=${encodeURIComponent(url)}`
        );
        return response;
      } catch (e) {
        // If conversion fails, return original URL
        console.error("Failed to convert to MP3:", e);
        this.$notify({
          text: "Warning: Failed to convert audio to MP3, using original file",
          group: "notification",
          type: "warning",
        });
        return url;
      }
    },
  },
};
</script>
<style>
.gray-fg {
  color: #999;
}
.inactive-bus {
  border: #999 1px solid !important;
}
.inactive-bus-text {
  color: #999 !important;
}
.active-bus {
  border: #5cb860 1px solid !important;
}
.active-bus {
  border: #5cb860 1px solid !important;
}
</style>
